<template>
    <div v-bind:class="app_container_class" id="app-container">
        <div class="d-flex container-fluid full-height" v-if="this.$root.cart_is_loaded && this.$root.product_is_loaded && this.$root.cart_is_empty === false">
            <div class="col-12 p-4 full-height" id="summary-component-container">
                <transition name="content-fade">
                    <div
                        class="card card-shadow-box card-no-border full-height"
                        ref="purchase_summary_container"
                        :key="locale"
                    >
                        <div class="card-header p-0">
                            <div class="row ms-0 me-0">
                                <div class="col catalog_header"></div>
                            </div>
                        </div>

                        <div id="summary-block" class="card-body p-4">
                            <div class="row ms-3 me-3 pb-3 pt-3">
                                <div class="col-5"></div>
                                <div class="col-2 text-center fw-bold text-uppercase">Prix</div>
                                <div class="col-2 text-center fw-bold text-uppercase">Quantité</div>
                                <div class="col-2 text-center fw-bold text-uppercase">Total</div>
                                <div class="col-1"></div>
                            </div>
                            <div class="summary_cart_items_list" show_swipe_up_down="" onscroll="$(this).find('.scroll_info').remove()">
                                <cartItem-component
                                    v-for="(cartItem, idx) in this.$root.cart_products"
                                    v-bind:cartItem="cartItem"
                                    v-bind:idx="idx"
                                    v-bind:place="this.place[idx]"
                                />
                                <div class="scroll_info">
                                    <divshow_btn_confirmer class="scroll_info_hover" onclick="$(this).parent().remove();"></divshow_btn_confirmer>
                                    <object data="/assets/kiosk/img/scroll-borne.svg"></object>
                                </div>

                            </div>
                        </div>

                        <div id="summary-footer" class="pb-5 pt-5 d-flex card-body justify-content-end flex-column full-height">
                            <cart-summary-component />
                        </div>
                    </div>
                </transition>
            </div>
        </div>
    </div>
    <transition name="content-fade">
        <footer-component
            :section="section"/>
    </transition>
</template>

<script>
import SeatingChartComponent from "../seating/SeatingChart";
import FooterComponent from "../footer/Footer";
import CartItemComponent from "../cart/CartItem";
import CartSummaryComponent from "../cart/CartSummary";

export default {
    name: "Summary",

    components: {
        'seating-chart-component': SeatingChartComponent,
        'footer-component': FooterComponent,
        'cartItem-component': CartItemComponent,
        'cart-summary-component': CartSummaryComponent,
    },

    data() {
        return {
            app_container_class: 'd-flex p-0 m-0 bg-phoenix-no-logo',
            summary_is_loaded: false,
            place: [],
        }
    },

    methods: {
        init()
        {
            this.$root.current_event_is_loaded.push('loading-summary');
            this.$root.current_loading_message = this.trans.get('kiosk.loading-summary');


            this.$root.valid_empty_cart();


        },
    },

    emits: [ 'send' ],

    created() {
        this.$root.show_btn_confirmer = true;
        this.place = this.$root.seating_place_info;
        this.$root.global_cancel_btn_disabled = false;
        this.init();
    },

    mounted() {
        this.$root.scrollbarVisible();
    },



    updated() {
        this.$root.scrollbarVisible();
        this.$root.valid_empty_cart();
    },



    props: {
        locale: String,
        section: String,
    },
}
</script>

<style scoped>

</style>
